export const billingHolds = {
  holdPrefix: 'Billing on hold',
  warningPrefix: 'Billing warning',
  flagHold: 'Billing Hold',
  flagWarning: 'Billing Warning',
  popoverHoldTitle: 'Billing on Hold',
  popoverWarningTitle: 'Billing Warning',
  holdLine: 'Claims for this patient are paused until the issue(s) below are resolved.',
  warningLine: "Claims for this month may be held if this isn't resolved by month end.",
  keepWorking: 'You can keep working with this patient.',
  bannerHold: (labels: string) => `Billing on hold: ${labels}. Claims for this patient are paused until this is fixed.`,
  bannerWarning: (labels: string) => `Billing warning: ${labels}. Claims for this month may be held if this isn't resolved by month end.`,
  // PSMs and Super Admins only, until the hold check places the Eligibility Unverified hold (z93r0b9pk0).
  bannerEligibilityUnverified: (reason: string) => `Eligibility Unverified: ${reason}.`,
  // True before and after the hold lands: the daily hold check places the Eligibility Unverified hold.
  unverifiedBillingPaused: 'Billing is paused until the payer confirms coverage. The daily hold check at 8:30 AM ET places the hold.',
  noReason: 'No reason specified.',
  manage: 'Manage',
  manageHold: 'Manage Hold',
  severity: {
    HOLD: 'Hold',
    WARNING: 'Warning'
  },
  filters: {
    billingWarning: 'Billing Warning',
    eligibilityUnverified: 'Eligibility Unverified',
    pauseType: 'Pause Type',
    pauseSubType: 'Pause Sub-type',
    all: 'All'
  },
  columns: {
    onHold: 'On Hold',
    holdReasons: 'Hold Reasons',
    pauseType: 'Pause Type',
    pauseSubType: 'Pause Sub-type'
  },
  yes: 'Yes',
  no: 'No',
  pauseTypes: {
    BILLING_HOLD: 'Billing Hold',
    MANUAL_HOLD: 'Manual Hold',
    OTHER: 'Other'
  } as Record<string, string>,
  pauseSubTypes: {
    NO_INSURANCE: 'No Insurance',
    INELIGIBLE_INSURANCE: 'Ineligible Insurance',
    ELIGIBILITY_UNVERIFIED: 'Eligibility Unverified',
    NO_ANNUAL_VISIT: 'No Annual Visit',
    NO_MONTHLY_CONTACT: 'No Monthly Contact',
    INCOMPLETE_SETUP: 'Incomplete Setup'
  } as Record<string, string>,
  otherDetail: 'Reason not available. Contact Support.',
  release: {
    restricted: 'Only Super Admins and PSMs can release a billing hold.',
    fromMonth: 'Release from billing month',
    fromMonthHelp: 'Insurance holds release this month and every month after. Earlier months stay held.',
    note: 'Note',
    noteRequired: 'A note is required to release from an earlier month.',
    notePlaceholder: 'e.g. Coverage confirmed for this month'
  }
};
